import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Field } from 'formik';
import { Row, Col, Button } from 'react-bootstrap';
import LocationInfo from '../../location/Location';
import ChangeLocation from '../../location/ChangeLocation';
import { Collapse } from 'react-bootstrap';
export default (function (props) {
  var store = props.store,
      location = props.location,
      results = props.results,
      setConfirmActive = props.setConfirmActive,
      storeId = props.storeId,
      waitlistId = props.waitlistId,
      hasActiveWaitlist = props.hasActiveWaitlist;

  var changeLocationHandler = function changeLocationHandler() {
    setOpen(!open);
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Collapse, {
    in: !open
  }, /*#__PURE__*/React.createElement("div", {
    id: "cb-collapse-location"
  }, /*#__PURE__*/React.createElement(LocationInfo, {
    store: store,
    location: location,
    changeLocationHandler: changeLocationHandler
  }))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Collapse, {
    in: open
  }, /*#__PURE__*/React.createElement("div", {
    id: "cb-collapse-locations"
  }, /*#__PURE__*/React.createElement(ChangeLocation, {
    store: store,
    location: location,
    results: results,
    showCurrent: false,
    changeLocationHandler: changeLocationHandler,
    setStoreHandler: changeLocationHandler
  }))))), /*#__PURE__*/React.createElement(Row, {
    className: "mt-5 mb-5"
  }, /*#__PURE__*/React.createElement(Col, null, hasActiveWaitlist && /*#__PURE__*/React.createElement("a", {
    className: "cb-color-red-800 mt-5",
    style: {
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return setConfirmActive(true);
    }
  }, "Cancel Place On Wait List"))));
});